import { Component, OnInit } from '@angular/core';
import { HttpMethod } from 'src/constants/constant';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import { ServiceManagerService } from '../service-manager.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  email: any = '';
  constructor(public serviceManager: ServiceManagerService) {
    serviceManager.navToValidRoute()
   }

  ngOnInit(): void {
  }
  forgotPassword(){
    var body = {
      "email":  this.email,
      "is_admin": true
    }
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: true,
      createLoaderAction: true
    }
    this.serviceManager.CallBackendServiceAPI('forgot-password', body, HttpMethod.POST, customOptions, false).subscribe( (data: any)=>{
      if(data){
      }
    })
  }
}
